import constants from '@playcastdotio/GlobalConfig';
import { LOCAL_SHELL_TIER_OVERRIDE } from './tierShellDevOverrides';

/**
 * Vite's DEV flag, read without a bare `import.meta`.
 *
 * `import.meta` is a module-syntax construct: Vite transforms it, but Jest runs
 * these files through ts-jest as CommonJS, where a bare `import.meta.env.DEV` is a
 * SyntaxError that prevents the whole suite from even loading. Reading it through
 * `Function` keeps it out of the static syntax and is guarded, so:
 *   - Vite/browser  → the real DEV flag
 *   - Jest/CJS      → false (never dev)
 */
export function isViteDevEnvironment(): boolean {
  try {
    // eslint-disable-next-line @typescript-eslint/no-implied-eval, no-new-func
    const meta = (Function('return import.meta') as () => { env?: { DEV?: boolean } } | undefined)();
    return meta?.env?.DEV === true;
  } catch {
    return false;
  }
}

/** True when tier override + onboarding shortcuts are allowed (local shell design). */
export function isRewardsShellDevMode(): boolean {
  if (!LOCAL_SHELL_TIER_OVERRIDE) return false;
  return constants.BRANCH === 'local' || constants.BRANCH === 'dev' || constants.BRANCH === 'unknown';
}

export function shouldUseLocalShellTierOverride(): boolean {
  return Boolean(LOCAL_SHELL_TIER_OVERRIDE) && isRewardsShellDevMode();
}

/** Pavilion onboarding gate bypass (welcome always, skip attestation pending, etc.). */
export function shouldBypassRewardsOnboardingGates(): boolean {
  if (constants.BRANCH === 'local' || isRewardsShellDevMode()) {
    return true;
  }
  // `host-electron:serve-pavilion` + Vite: PlayJector/driverState may never settle; still need rewards UI.
  if (isViteDevEnvironment() && constants.BRANCH === 'dev') {
    return true;
  }
  return false;
}
